import { httpInstance } from '@/services/httpInstance';

const getFeaturesFlagCommerceService = async () => {
  let res;
  const endpoint = '/back-office/v1/features-flag-commerce';
  await httpInstance.get(
    endpoint,
  ).then((data) => {
    res = data;
  }).catch((err) => {
    res = err.response;
  });
  return res;
};

export default getFeaturesFlagCommerceService;
